import { MutationFunctionOptions, MutationHookOptions, MutationResult } from "@apollo/client";
import { useMutation } from "../../../hooks";
import { FetchResult } from "@apollo/client/link/core";
import { replaceInMatterExclusionsCache } from "../../query";
import { UpdateExclusionMutation, UpdateExclusionMutationVariables } from "~/gql/graphql";
import { Exclusion } from "@design-system";
import { graphql } from "~/gql";

export const UPDATE_EXCLUSION = graphql(/* GraphQL */ `
  mutation updateExclusion($id: Float!, $input: ExclusionUpdateInput!) {
    updateExclusion(id: $id, input: $input) {
      ...ExclusionFragment
    }
  }
`);

export const UPDATE_EXCLUSIONS = graphql(/* GraphQL */ `
  mutation updateExclusions($input: [UpdateManyExclusionsInput!]!) {
    updateExclusions(input: $input) {
      ...ExclusionFragment
    }
  }
`);

export type UpdateExclusionMutationFunction = (
  matterId: number,
  exclusion: Exclusion,
  options?: MutationFunctionOptions<UpdateExclusionMutation, UpdateExclusionMutationVariables>
) => Promise<FetchResult<UpdateExclusionMutation>>;

export function useUpdateExclusionMutation(
  options?: MutationHookOptions<UpdateExclusionMutation, UpdateExclusionMutationVariables>
): [UpdateExclusionMutationFunction, MutationResult<UpdateExclusionMutation>] {
  const [mutationFunction, mutationResult] = useMutation(UPDATE_EXCLUSION, {
    errorPolicy: "none",
    ...(options || {}),
  });
  const updateExclusionMutation: UpdateExclusionMutationFunction = (
    matterId,
    exclusion,
    options
  ) => {
    const { id, text, fromLibraryExclusionId } = exclusion;
    return mutationFunction({
      variables: {
        id,
        input: {
          matter: {
            connect: {
              id: matterId,
            },
          },
          text: {
            set: text,
          },
          fromLibraryExclusion: {
            disconnect: {},
            ...(fromLibraryExclusionId
              ? {
                  connect: {
                    id: fromLibraryExclusionId,
                  },
                }
              : {
                  disconnect: {},
                }),
          },
        },
      },
      update(cache, { data }) {
        replaceInMatterExclusionsCache(cache, matterId, data?.updateExclusion!);
      },
      ...(options || {}),
    });
  };
  return [updateExclusionMutation, mutationResult];
}
